import { api } from "@lumberset/api-client";
import { HelpCenter } from "@lumberset/support-ui";
import { Container, SectionHeader } from "@lumberset/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/help/")({ component: HelpIndex });

function HelpIndex() {
  const navigate = useNavigate();
  return (
    <Container className="divide-y p-0">
      <SectionHeader
        level="h1"
        title="Help Center"
        description="Short articles on every part of LumberSet. Search, or browse by topic."
      />
      <div className="px-6 py-5">
        <HelpCenter
          api={api}
          autoFocus
          onOpenArticle={(slug) => navigate({ to: "/help/$slug", params: { slug } })}
        />
      </div>
    </Container>
  );
}
